var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagicIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M26 15a.997.997 0 01-.707-.293l-4-4a.999.999 0 111.414-1.414l4 4A.999.999 0 0126 15zM38 10a1 1 0 01-1-1V3a1 1 0 012 0v6a1 1 0 01-1 1zM50 15a.999.999 0 01-.707-1.707l4-4a.999.999 0 111.414 1.414l-4 4A.997.997 0 0150 15zM61 27h-6a1 1 0 010-2h6a1 1 0 010 2zM54 43a.997.997 0 01-.707-.293l-4-4a.999.999 0 111.414-1.414l4 4A.999.999 0 0154 43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.086 24.5L2.293 51.293a.999.999 0 000 1.414l9 9a.997.997 0 001.414 0L39.5 34.914 29.086 24.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M48.707 24.293l-9-9a.999.999 0 00-1.414 0L30.5 23.086 40.914 33.5l7.793-7.793a.999.999 0 000-1.414z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicIcon);
export default __webpack_public_path__ + "static/media/magic-icon.dfb77480.svg";
export { ForwardRef as ReactComponent };